import React from 'react';
import { withRouter } from 'react-router-dom';
import { FlexBox, InlineItemWithMargin, LogoutIcon } from '../Components';
import Search from './Search';
import OrderListButton from './OrderListButton';
import CurrentOrderButton from './CurrentOrderButton';
import Sync from './Sync';
import { BarcodeScanner } from './BarcodeScanner';
import AppContext from '../AppContext';
import { getCurrentOrderCustomer } from '../selectors';

const TopMenu = (props) => {
  const logout = () => {
    if (!window.indexedDB) return;
    window.indexedDB
      .databases()
      .then((r) => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < r.length; i++) window.indexedDB.deleteDatabase(r[i].name);
      })
      .then(() => {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      });
  };

  return (
    <AppContext.Consumer>
      {(context) => {
        const currentOrderCustomer = getCurrentOrderCustomer(context);
        const hasCurrentOrder = !!currentOrderCustomer;

        return (
          <>
            <FlexBox alignItems="center">
              { !props.marketing && (
                <>
                  {hasCurrentOrder && <BarcodeScanner />}
                  <InlineItemWithMargin>
                    <CurrentOrderButton />
                  </InlineItemWithMargin>
                  <InlineItemWithMargin>
                    <OrderListButton />
                  </InlineItemWithMargin>
                </>
              )}
              <InlineItemWithMargin>
                <Search anchorRef={props.anchorRef} />
              </InlineItemWithMargin>
              <InlineItemWithMargin>
                <Sync />
              </InlineItemWithMargin>
              <div style={{ display: 'none' }}>
                <InlineItemWithMargin>
                  <LogoutIcon onClick={logout} />
                </InlineItemWithMargin>
              </div>
            </FlexBox>
          </>
        );
      }}
    </AppContext.Consumer>
  );
};

export default withRouter(TopMenu);
